import { Component, OnInit } from '@angular/core';
import {timeout} from 'rxjs/operators';
import {ConfirmationService} from '../services/confirmation.service';
import {ActivatedRoute} from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  loading = true;
  statusmessage = 'Please wait while we create your team account.';
  status: 'success' | 'loading' | 'failure' = 'loading';
  private uid: string;
  private rid: string;

  constructor(private confirmationService: ConfirmationService, private route: ActivatedRoute, private title: Title) {
    this.title.setTitle("Xeotek KaDeck - Confirm your account");
    this.route.queryParams.subscribe(params => {
      console.log('params', params);
      this.uid = params.uid;
      this.rid = params.rid;

      console.log('params', this.uid);
      console.log('params', this.rid);

      this.confirmationService.confirmAccount(this.rid, this.uid).subscribe(value => {

          if (value['errorMessage']) {
            console.log('Error', value);
            this.status = 'failure';

            if (value['errorMessage'] === 'mail is not defined') {
              this.statusmessage = 'Account was already created or request could not be found.';
              return;
            }

            this.statusmessage = value['errorMessage'];
            return;
          }


          if (value['body'] && value['body'] === 'Could not complete  action - missing mail.') {
            this.statusmessage = 'Malformed confirmation link. Could not create team.';
            this.status = 'failure';

            return;
          }
          console.log('Success', value);
          this.status = 'success';
          this.statusmessage = 'Your team account has been successfully created.';
        },
        error => {
        console.log('Error', error);
        this.status = 'failure';
        this.statusmessage = 'Failed: ' + error.msg;
        });
    });
  }

  ngOnInit(): void {
  }



}
